// EU member states
export const EU_COUNTRIES = new Set([
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
]);

// EEA countries (EU + Norway, Iceland, Liechtenstein)
export const EEA_COUNTRIES = new Set([...EU_COUNTRIES, "NO", "IS", "LI"]);

// GDPR countries (EU + other European countries that apply GDPR-like regulations)
export const GDPR_COUNTRIES = new Set([
  ...EU_COUNTRIES,
  "GB", // UK
  "CH", // Switzerland
  "XK", // Kosovo
  "RS", // Serbia
  "ME", // Montenegro
  "AL", // Albania
  "MK", // North Macedonia
  "BA", // Bosnia and Herzegovina
]);

// US states with privacy laws (CCPA and similar)
export const CCPA_STATES = new Set([
  "CA", // California
  "VA", // Virginia
  "CO", // Colorado
  "CT", // Connecticut
  "UT", // Utah
  "IA", // Iowa
  "IN", // Indiana
  "TN", // Tennessee
  "MT", // Montana
  "TX", // Texas
  "OR", // Oregon
  "DE", // Delaware
  "NJ", // New Jersey
  "NH", // New Hampshire
]);

export const languageMap: Record<string, string> = {
  // European languages
  de: "DE", // German
  fr: "FR", // French
  it: "IT", // Italian
  es: "ES", // Spanish
  pt: "PT", // Portuguese
  nl: "NL", // Dutch
  pl: "PL", // Polish
  ro: "RO", // Romanian
  bg: "BG", // Bulgarian
  hr: "HR", // Croatian
  cs: "CZ", // Czech
  da: "DK", // Danish
  et: "EE", // Estonian
  fi: "FI", // Finnish
  el: "GR", // Greek
  hu: "HU", // Hungarian
  ga: "IE", // Irish
  lv: "LV", // Latvian
  lt: "LT", // Lithuanian
  lb: "LU", // Luxembourgish
  mt: "MT", // Maltese
  sk: "SK", // Slovak
  sl: "SI", // Slovenian
  sv: "SE", // Swedish

  // Non-EU European languages
  en: "GB", // English (UK)
  sq: "AL", // Albanian
  sr: "RS", // Serbian
  cnr: "ME", // Montenegrin
  mk: "MK", // Macedonian
  bs: "BA", // Bosnian

  // Swiss languages
  rm: "CH", // Romansh
  de_CH: "CH", // Swiss German
  fr_CH: "CH", // Swiss French
  it_CH: "CH", // Swiss Italian

  // US/Canada
  en_US: "US", // US English
  en_CA: "CA", // Canadian English
  fr_CA: "CA", // Canadian French
};

export const timezoneMap: Record<string, string> = {
  // Europe
  "Europe/Berlin": "DE",
  "Europe/Paris": "FR",
  "Europe/Rome": "IT",
  "Europe/Madrid": "ES",
  "Europe/Lisbon": "PT",
  "Europe/Amsterdam": "NL",
  "Europe/Warsaw": "PL",
  "Europe/Bucharest": "RO",
  "Europe/Sofia": "BG",
  "Europe/Zagreb": "HR",
  "Europe/Prague": "CZ",
  "Europe/Copenhagen": "DK",
  "Europe/Tallinn": "EE",
  "Europe/Helsinki": "FI",
  "Europe/Athens": "GR",
  "Europe/Budapest": "HU",
  "Europe/Dublin": "IE",
  "Europe/Riga": "LV",
  "Europe/Vilnius": "LT",
  "Europe/Luxembourg": "LU",
  "Europe/Malta": "MT",
  "Europe/Bratislava": "SK",
  "Europe/Ljubljana": "SI",
  "Europe/Stockholm": "SE",
  "Europe/Vienna": "AT",
  "Europe/Brussels": "BE",
  "Europe/Nicosia": "CY",

  // Non-EU Europe
  "Europe/London": "GB",
  "Europe/Zurich": "CH",
  "Europe/Belgrade": "XK", // Kosovo uses Belgrade timezone
  "Europe/Podgorica": "ME",
  "Europe/Tirane": "AL",
  "Europe/Skopje": "MK",
  "Europe/Sarajevo": "BA",

  // US timezones
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Anchorage": "US",
  "Pacific/Honolulu": "US",
};

export const TCF_SETTINGS_ID = "rWiDt-jTf7k5L2";
export const GDPR_SETTINGS_ID = "egjgOnAMHobwN_";
export const CCPA_SETTINGS_ID = "PpPOxcBmfrLksC";
